<template>
    <div class="block wqjb" id="wqjb">
        <div class="itemTitBox wow animated bounceInRight">
            <p class="big">往期嘉宾</p>
            <p class="small">PREVIOUS GUEST</p>
        </div>
        <div class="wqjb_con">
            <ul>
                <li v-for="(item, index) in dataJson.conference_guest" :key="index">
                    <img class="img_data" :src="item.img" />
                    <p class="title">{{item.title}}</p>
                    <div class="name">{{item.name}}</div>
                    <!-- <div class="img_qiu"></div> -->
                </li>
                <!-- <p style="clear: both;"></p> -->
            </ul>
            <!-- <p style="clear: both;"></p> -->
        </div>
    </div>
</template>
<script>
import dataJson from "../assets/index.json";
export default {
    data() {
        return {
            dataJson
        };
    }
};
</script>
<style>
@media (max-width: 900px) {
  .wqjb_con ul li  {
    width: 300px !important;
  }
}
</style>
<style lang="less" scoped>
@import url("../views/index.less");
.wqjb_con {
    width: 669px;
    margin: 0 auto;
    ul {
        margin-top: 26px;
        display: flex;
        justify-content: space-around;
        flex-wrap: wrap;
        li {
            // float: left;
            // margin-right: 13px;
            margin-bottom: 12px;
            width: 100px;
            transition: all 0.6s;
            position: relative;
            z-index: 10;
                // height: 176px;
                width: 100px;
            img {
                width: 100%;
                // height: 135px;
            }
            .img_qiu{
                width: 30px;
                height: 30px;
                background: linear-gradient(-48deg, #EC0043 0%, #001374 76%);
                opacity: 0.67;
                border-radius: 50%;
                position: absolute;
                left: 50%;
                margin-left: -15px;
                bottom: 0px;
                z-index: -1;
            }
            .title{
                color: white;
                font-size: 8px;
                font-family: MicrosoftYaHei;
                font-weight: 400;
                text-align: center;
                margin-top: 10px;
                line-height: 1.3;
            }
            .name{
                font-size: 9px;
                font-family: MicrosoftYaHei;
                font-weight: bold;
                color: white;
                text-align: center;
                line-height: 1.3;
            }
            // &:nth-last-of-type(1),&:nth-last-of-type(7),&:nth-last-of-type(13),&:nth-last-of-type(19),&:nth-last-of-type(25),&:nth-last-of-type(31),&:nth-last-of-type(37){
            //     margin: 0;
            // }
        }
        li:hover{
            transform: scale(1.1);
            z-index: 99;
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/components/wqjb.vue